import { Link } from 'react-router-dom';
import { Mail, Phone, CalendarCheck, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';
import { PageHero, Reveal } from '../components/Reveal';
import LeadForm from '../components/LeadForm';
import { CONTACT } from '../data/config';

const INFO = [
  { icon: Mail, label: 'Email', value: CONTACT.email, href: `mailto:${CONTACT.email}`, testid: 'contact-email-placeholder' },
  { icon: Phone, label: 'Phone', value: CONTACT.phone, href: `tel:${CONTACT.phone.replace(/\s+/g, '')}`, testid: 'contact-phone-placeholder' },
  { icon: CalendarCheck, label: 'Calendar Booking', value: 'Unlocks after package payment', href: '/book-consultation', testid: 'contact-calendar-placeholder' },
];

const Contact = () => (
  <main data-testid="contact-page">
    <SEO
      title="Contact CareerWithRaaj — Let's Build Your Career Roadmap"
      description="Get in touch with CareerWithRaaj for career guidance, consultations, roadmaps, and skill development support."
    />
    <PageHero
      overline="Contact"
      title="Let's Build Your Career Roadmap"
      description="Tell us where you are in your journey — we'll help you figure out the next right step."
    />

    <section className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid items-start gap-14 lg:grid-cols-5">
          <Reveal delay={0.1} className="lg:col-span-3">
            <div className="rounded-3xl border border-line bg-white p-8 shadow-card-hover md:p-10" data-testid="contact-form-card">
              <h2 className="font-display text-2xl font-bold text-navy">Send Us a Message</h2>
              <p className="mt-2 text-sm text-slate-500">We usually respond within one working day.</p>
              <div className="mt-7">
                <LeadForm source="contact" showMessage buttonLabel="Submit" interestLabel="Area of Interest" />
              </div>
            </div>
          </Reveal>

          <div className="space-y-4 lg:col-span-2">
            {INFO.map((item, i) => {
              const Icon = item.icon;
              return (
                <Reveal key={item.label} delay={0.08 * i}>
                  <div className="rounded-2xl border border-line bg-mist p-6" data-testid={item.testid}>
                    <div className="flex items-center gap-3">
                      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy text-coral">
                        <Icon className="h-4.5 w-4.5" />
                      </span>
                      <p className="text-sm font-bold text-navy">{item.label}</p>
                    </div>
                    {item.href ? (
                      <a
                        href={item.href}
                        target={item.href.startsWith('http') ? '_blank' : undefined}
                        rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                        data-testid={`${item.testid}-link`}
                        className="mt-4 block rounded-lg border border-line bg-white px-4 py-2.5 font-mono text-xs text-slate-600 transition-colors hover:border-coral hover:text-coral"
                      >
                        {item.value}
                      </a>
                    ) : (
                      <code className="mt-4 block rounded-lg border border-line bg-white px-4 py-2.5 font-mono text-xs text-slate-500">
                        {item.value}
                      </code>
                    )}
                  </div>
                </Reveal>
              );
            })}
            <Reveal delay={0.25}>
              <Link
                to="/book-consultation"
                data-testid="contact-book-consultation-cta"
                className="flex items-center justify-center gap-2 rounded-2xl bg-coral py-4 text-sm font-semibold text-white transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-coral-deep"
              >
                Book a Consultation <ArrowRight className="h-4 w-4" />
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  </main>
);

export default Contact;
